module.exports = __webpack_public_path__ + "static/owl@2x-2c4886e6770e19c210dce75e2f2eb0b9.png";